import { useRouter } from 'next/router';
import React from 'react';
import { getRouterLocale } from '../../../../Utils/i18Utils/constant';
import { getSearchParams } from '../../../Parenting/common';
import AnchorCoverTag from '../../../StoreHomePage/AnchorCoverTag';
import { OnHoverStoreHeaderStyling } from '../styled';
import DownloadApp from './DownloadApp';
import { CategoriesStyling } from './styled';
// import { CategoriesStyling, OnHoverStoreHeaderStyling } from "./styled";

export default function OnHoverStoreHeader(props) {
  const { categoryData, isDownloadApp } = props;

  const router = useRouter();
  const categoryManipulatedData = [];

  categoryData?.map((element) => {
    let obj = {
      name: element?.tabName,
      deeplink: element?.key,
      categories: [],
    };

    if (element?.subCategories) {
      element?.subCategories?.map((item) => {
        if (item?.subCategories && !item?.tabName?.includes('Ingredient')) {
          item?.subCategories?.map((elm) => {
            let linkObj = {
              tabName: elm.tabName,
              deeplink: elm?.key,
            };
            obj.categories.push(linkObj);
          });
        } else if (!item?.tabName?.includes('Ingredient')) {
          let linkObj = {
            tabName: item.tabName,
            deeplink: item?.key,
          };
          obj.categories.push(linkObj);
        }
      });
      categoryManipulatedData.push(obj);
    } else {
      categoryManipulatedData.push(element);
    }
  });
  const callbackFunction = (
    index,
    deeplinkValue,
    element,
    e,
    obj,
    showLandingPage = false,
  ) => {
    setTimeout(() => {
      router.push(deeplinkValue + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  let leftShift = '-4vw';
  if (categoryManipulatedData?.[0]?.categories || isDownloadApp) {
    leftShift = '-35vw';
  }

  return (
    <OnHoverStoreHeaderStyling leftShift={leftShift}>
      <CategoriesStyling
        showColumnStyle={categoryManipulatedData?.[0]?.categories?.length}
      >
        {isDownloadApp ? (
          <DownloadApp />
        ) : (
          categoryManipulatedData?.map((element, index) => {
            const categoryUrl = element?.deeplink || element?.key;
            return (
              <div key={'brandHead' + index} style={{ minWidth: '130px' }}>
                <AnchorCoverTag
                  url={categoryUrl}
                  key={`searches-${index}`}
                  callbackFunction={callbackFunction}
                  element={element}
                  cardEffect={'brandHeading'}
                  fragmentClass={'brandHeading'}
                >
                  {element?.name || element?.tabName}
                </AnchorCoverTag>
                {element?.categories?.map((item, idx) => {
                  const url = item?.deeplink;
                  return (
                    <AnchorCoverTag
                      url={url}
                      key={'catAnchor' + index + idx}
                      callbackFunction={callbackFunction}
                      element={item}
                      cardEffect={'content'}
                    >
                      {item?.tabName}
                    </AnchorCoverTag>
                  );
                })}
              </div>
            );
          })
        )}
      </CategoriesStyling>
    </OnHoverStoreHeaderStyling>
  );
}
